var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { EventEmitter } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
var BrandingComponent = /** @class */ (function () {
    function BrandingComponent() {
        this.colorsSubmitted = new EventEmitter();
        this.imageSubmitted = new EventEmitter();
        this.imageRemoved = new EventEmitter();
        this.colorsReset = new EventEmitter();
        this.INCLUDE_COLORS = false;
        this.INCLUDE_PLACEHOLDER = false;
        this._branding = new FormGroup({
            colors: new FormGroup({
                primary: new FormControl(''),
                secondary: new FormControl('')
            }),
            media: new FormGroup({
                memoBannerImage: new FormControl('', Validators.required),
                menuBackgroundImage: new FormControl('', Validators.required),
                logoIcon: new FormControl('', Validators.required)
            })
        });
    }
    Object.defineProperty(BrandingComponent.prototype, "branding", {
        get: function () {
            return this._branding;
        },
        set: function (value) {
            if (value) {
                var patch = __assign({}, value);
                this._branding.get('media').reset();
                patch.media = value.media.reduce(function (prev, next) {
                    var _a;
                    return (__assign({}, prev, (_a = {}, _a[next.purpose] = next, _a)));
                }, {});
                this._branding.patchValue(patch);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BrandingComponent.prototype, "primary", {
        get: function () {
            return this._branding.get('colors').get('primary').value;
        },
        set: function (value) {
            this._branding
                .get('colors')
                .get('primary')
                .setValue(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BrandingComponent.prototype, "secondary", {
        get: function () {
            return this._branding.get('colors').get('secondary').value;
        },
        set: function (value) {
            this.branding
                .get('colors')
                .get('secondary')
                .setValue(value);
        },
        enumerable: true,
        configurable: true
    });
    BrandingComponent.prototype.onSubmitColors = function () {
        this.colorsSubmitted.emit(this.branding.value.colors);
    };
    BrandingComponent.prototype.resetColors = function () {
        this.colorsReset.emit();
    };
    BrandingComponent.prototype.resetImage = function (controlName) {
        this.imageRemoved.emit(this._branding.get('media').get(controlName).value);
    };
    BrandingComponent.prototype.onImageSubmitted = function (purpose) {
        if (this.branding.get('media').get(purpose) &&
            this.branding.get('media').get(purpose).value &&
            this.branding.get('media').get(purpose).valid) {
            if (this.branding.get('media').get(purpose).value.purpose) {
                // Image has already been saved/used
                return;
            }
            this.imageSubmitted.emit(__assign({}, this.branding.get('media').get(purpose).value, { purpose: purpose }));
        }
    };
    return BrandingComponent;
}());
export { BrandingComponent };
